import { pxToRem, themeGet } from '@pocketlaw/tetris';
import styled, { css } from 'styled-components';
import { MiramisLogotype } from 'shared/domains/common-ui';
import { ICON_CONTAINER_WIDTH, SIDEBAR_PADDING, TRANSITION_DURATION, TRANSITION_SETTINGS } from '../config';
const ACTIONS_GAP = themeGet('spacing.md');
export const SidebarMenuHeaderContainer = styled.div `
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: ${themeGet('spacing.2xl')};
  padding: ${SIDEBAR_PADDING};
`;
export const ActionsContainer = styled.div `
  display: flex;
  flex-direction: column;

  > :not(:first-child) {
    margin-top: ${ACTIONS_GAP};
    transition:
      all ${TRANSITION_SETTINGS},
      margin-top ${TRANSITION_DURATION}ms ease-out,
      margin-left ${TRANSITION_DURATION}ms ease-in;
  }

  ${({ $minimized }) => !$minimized &&
    css `
      > :not(:first-child) {
        width: calc(100% - ${ICON_CONTAINER_WIDTH} - ${ACTIONS_GAP});
        margin-top: -${ICON_CONTAINER_WIDTH};
        margin-left: calc(${ICON_CONTAINER_WIDTH} + ${ACTIONS_GAP});
        transition:
          all ${TRANSITION_SETTINGS},
          margin-top ${TRANSITION_DURATION}ms ease-in,
          margin-left ${TRANSITION_DURATION}ms ease-out;
      }
    `};
`;
export const StyledLogotype = styled(MiramisLogotype) `
  width: auto;
  height: ${pxToRem(32)};
`;
export const ToggleButton = styled.button `
  display: flex;
  border: none;
  height: ${pxToRem(32)};
  align-items: center;
  background-color: transparent;
  cursor: pointer;
  padding: 0;
  margin: 0;
`;
